(function() {
	'use strict';

	angular
		.module('cacmDynamicsAccountTransactionModule')
		.directive('cacmDynamicsAccountTransaction', directive);

	directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'cacmService'];

	function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, cacmService) {

		var directiveScope = _.clone(boxTmplScope);
		directiveScope.highlighting = '=';

		return {
			scope: directiveScope,
			template: boxTmplHtml,
			controller: ['$rootScope', '$scope', '$controller',
				function ($rootScope, $scope, $controller) {

					$scope.init = function() {
						$scope.dirCtxt = {
							isExpanded: false
						};
					};

					$scope.toggleIsExpanded = function() {
						$scope.dirCtxt.isExpanded = !$scope.dirCtxt.isExpanded;
					};

					if (_.isEmpty($scope.highlighting)) {
						$scope.isHighlighted = false;
					} else {
						$scope.isHighlighted = true;
					}

					// Box Template
					$scope.baseTemplatePath = '/app/shared/cacm/dynamicsAccountTransaction/cacmDynamicsAccountTransaction.[Template].tpl.html';
					$controller('BoxTmplController', { $scope: $scope });
				}],
			link: function (scope, elem, attrs) {
				scope.init();
				boxTmplLinkFn(scope, elem, attrs);
			}
		}
	}
})();